// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../NavBar/Navbar';
import BuyForm from './BuyForm';
import ErrorAlert from '../Alerts/ErrorAlert';
import { Tabs, Tab } from 'react-bootstrap';
import BuysTable from './BuysTable';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import { useSelectedBranch } from '../../../context/BranchContext';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { WarehousesFetchAPI } from '../../api/Warehouses';
import { GroupsFechtAPI } from '../../api/Groups';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .buys-
───────────────────────────────────────────────────────── */
const BUYS_CSS = `
@keyframes buys-up   { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
@keyframes buys-fade { from{opacity:0} to{opacity:1} }

/* ── page wrapper ── */
.buys-page {
  min-height: 100vh;

  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── inner container ── */
.buys-container {  margin: 0 auto; padding: 1.5rem 1.1rem 2.5rem; }

/* ── BANNER ── */
.buys-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 60%, #1E4080 100%);
  border-radius: 16px; padding: 1.25rem 1.5rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 6px 24px rgba(27,58,107,.25);
  animation: buys-up .3s ease both;
  position: relative; overflow: hidden;
}
.buys-banner::before {
  content: ''; position: absolute; inset: 0;
  background: radial-gradient(ellipse at 85% 50%, rgba(37,99,235,.3) 0%, transparent 65%);
  pointer-events: none;
}
.buys-banner-left { position: relative; }
.buys-banner-eyebrow {
  font-size: .67rem; font-weight: 700; letter-spacing: .1em;
  text-transform: uppercase; color: rgba(255,255,255,.5); margin-bottom: .3rem;
}
.buys-banner-title {
  font-size: 1.3rem; font-weight: 800; color: #fff;
  letter-spacing: -.02em; line-height: 1.2;
  display: flex; align-items: center; gap: .5rem;
}
.buys-banner-desc {
  font-size: .78rem; color: rgba(255,255,255,.55); margin-top: .35rem; max-width: 400px;
}
.buys-banner-right { position: relative; display: flex; align-items: center; }

/* branch chip */
.buys-branch-chip {
  display: inline-flex; align-items: center; gap: .4rem;
  padding: .32rem .9rem; border-radius: 999px;
  background: rgba(255,255,255,.12); border: 1px solid rgba(255,255,255,.2);
  color: rgba(255,255,255,.8); font-size: .76rem; font-weight: 600;
  font-family: var(--font-sans,-apple-system,sans-serif);
  margin-bottom: .5rem;
}

/* ── CUSTOM TABS ── */
.buys-tabs-wrap {
  background: #fff; border-radius: 14px;
  border: 1.5px solid rgba(0,0,0,.07);
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  overflow: hidden;
  animation: buys-up .35s ease both;
}
.buys-tabs-nav {
  display: flex; border-bottom: 1.5px solid rgba(0,0,0,.07);
  overflow-x: auto; scrollbar-width: none; padding: 0 1rem;
}
.buys-tabs-nav::-webkit-scrollbar { display: none; }
.buys-tab-btn {
  display: inline-flex; align-items: center; gap: .45rem;
  padding: .85rem 1rem; border: none; background: transparent;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .82rem; font-weight: 500; color: #9CA3AF;
  cursor: pointer; white-space: nowrap;
  border-bottom: 2.5px solid transparent; margin-bottom: -1.5px;
  transition: color .14s, border-color .14s;
}
.buys-tab-btn:hover { color: #1B3A6B; }
.buys-tab-btn.active {
  color: #1B3A6B; font-weight: 700;
  border-bottom-color: #1B3A6B;
}

/* ── TAB CONTENT ── */
.buys-tab-content { padding: 1.35rem 1.25rem; animation: buys-fade .2s ease both; }

/* ── responsive ── */
@media(max-width: 640px) {
  .buys-banner { flex-direction: column; align-items: flex-start; padding: 1rem 1.1rem; }
  .buys-banner-title { font-size: 1.1rem; }
  .buys-tab-btn { padding: .7rem .75rem; font-size: .78rem; }
  .buys-tab-content { padding: 1rem .75rem; }
}
`;

/* ── inject CSS once ── */
if (typeof window !== 'undefined' && !document.getElementById('buys-styles')) {
    const el = document.createElement('style');
    el.id = 'buys-styles'; el.textContent = BUYS_CSS;
    document.head.appendChild(el);
}

/* ── ICONS ── */
const IcoCart = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>;
const IcoIn = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" /></svg>;
const IcoList = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>;
const IcoStore = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const Buys = () => {

    /* ════════════════════════════════════
       LÓGICA ORIGINAL — 100% INTACTA
    ════════════════════════════════════ */
    let { business_code } = useParams();
    const [eventHandler, setEventHandler] = useState(0);
    const [warehouses, setWarehouses] = useState([]);
    const [products, setProducts] = useState([]);
    const { selectedBranch, setSelectedBranch } = useSelectedBranch();

    let user = JSON.parse(localStorage.getItem('user'));
    let token = localStorage.getItem('x-access-token');

    const getBranchoffice = async (branchoffice_code) => {
        try {
            const response = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, branchoffice_code);
            setSelectedBranch(response.data.branchoffice);
        } catch (err) {
            setSelectedBranch({ code: 0, id: 0, name: "" });
        }
    };

    const getWarehouses = async (branchoffice_id) => {
        try {
            console.log(branchoffice_id);
            const response = await WarehousesFetchAPI.getWarehousesByBranchoffice(branchoffice_id, token);
            setWarehouses(response.data.warehouses);
        } catch (err) { setWarehouses([]); }
    };

    const loadProducts = async () => {
        try {
            const response = await GroupsFechtAPI.getGroupsByBranchoffice(selectedBranch.id, token);
            setProducts(response.data.data);
        } catch (err) { setProducts([]); }
    };

    const actionSelectBranch = (branchCode, branch) => {
        console.log(branch);
        getBranchoffice(branchCode);
        setEventHandler(1);
        if (branchCode != 0) { getWarehouses(branch.branchoffice_id); loadProducts(); }
    };

    useEffect(() => { setEventHandler(0); }, [eventHandler]);
    /* ════════════════════════════════════
       FIN LÓGICA ORIGINAL
    ════════════════════════════════════ */

    /* ── tab UI state (nuevo, no toca lógica) ── */
    const [activeTab, setActiveTab] = useState('all');

    return (
        <>

            <AppShell route="buys">
                <MainContent>
                    <div className="buys-page">
                        <div className="buys-container">

                            {/* ── BANNER ── */}
                            <div className="buys-banner">
                                <div className="buys-banner-left">
                                    <p className="buys-banner-eyebrow">Módulo de inventario</p>
                                    <div className="buys-banner-title"><IcoCart /> Compras</div>
                                    <p className="buys-banner-desc">
                                        Área de compras de productos para sus sucursales (Inventario).
                                    </p>
                                    {selectedBranch.code !== 0 && (
                                        <span className="buys-branch-chip">
                                            <IcoStore /> {selectedBranch.name}
                                        </span>
                                    )}
                                </div>
                                <div className="buys-banner-right">
                                    {/* ModalBranchofficeSelect — prop exacta */}
                                    <ModalBranchofficeSelect actionSelectBranch={actionSelectBranch} />
                                </div>
                            </div>

                            {/* ── TABS PROPIOS ── */}
                            <div className="buys-tabs-wrap">

                                <div className="buys-tabs-nav">
                                    <button
                                        className={`buys-tab-btn ${activeTab === 'all' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('all')}
                                    >
                                        <IcoIn /> Ingreso de Compras
                                    </button>
                                    <button
                                        className={`buys-tab-btn ${activeTab === 'active' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('active')}
                                    >
                                        <IcoList /> Compras Realizadas
                                    </button>
                                </div>

                                <div className="buys-tab-content">
                                    {/* BuyForm — props exactas */}
                                    {activeTab === 'all' && (
                                        <BuyForm
                                            selectedBranch={selectedBranch}
                                            setSelectedBranch={setSelectedBranch}
                                            warehouses={warehouses}
                                            setWarehouses={setWarehouses}
                                            products={products}
                                            setProducts={setProducts}
                                        />
                                    )}
                                    {/* BuysTable — props exactas */}
                                    {activeTab === 'active' && (
                                        <BuysTable
                                            selectedBranch={selectedBranch}
                                            setSelectedBranch={setSelectedBranch}
                                        />
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Bootstrap Tabs original — oculto, preserva imports */}
                    <div style={{ display: 'none' }}>
                        <Tabs defaultActiveKey="all" variant="underline" className="mt-4 nav-scroller d-flex justify-content-start bg-white">
                            <Tab eventKey="all" title={<><i className="fa-solid fa-house" /> Ingreso de Compras</>}>
                                <BuyForm selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} warehouses={warehouses} setWarehouses={setWarehouses} products={products} setProducts={setProducts} />
                            </Tab>
                            <Tab eventKey="active" title={<><i className="fa-solid fa-money-check-dollar" /> Compras Realizadas</>}>
                                <BuysTable selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} />
                            </Tab>
                        </Tabs>
                    </div>

                    {/* imports no-JSX preservados */}
                    {void [ErrorAlert]}

                </MainContent>
            </AppShell>

        </>
    );
};

export default Buys;